import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
                className={`block will-change-transform ${className}`}
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function Kicker({ children, light = false }) {
    return (
        <span
            className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] ${
                light ? "text-[#B8500A]" : "text-[#FFA200]"
            }`}
        >
            <span className="h-[2px] w-6 bg-current" />
            {children}
        </span>
    );
}
